<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!equipment_id">{{ 'Add Items' | translate }}</v-card-title>
              <v-card-title v-if="equipment_id">{{ 'Edit Items' | translate }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Equipment name' | translate"
                            v-model="equip_name"
                            name="equip_name"
                            autocomplete="off"
                            :rules="equipmentnameRules"
                            :disabled="(isUser? true : false)"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Location' | translate"
                            v-model="location"
                            name="location"
                            autocomplete="off"
                            :rules="locationRules"
                            :disabled="(isUser? true : false)"
                            required
                          >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Class' | translate"
                            v-model="equipmentclass"
                            name="equipmentclass"
                            autocomplete="off"
                            :disabled="(isUser? true : false)"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Maker' | translate"
                            v-model="maker"
                            name="maker"
                            autocomplete="off"
                            :disabled="(isUser? true : false)"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            type="number"
                            :label="'Number in stock' | translate"
                            v-model="num_in_stock"
                            name="num_in_stock"
                            autocomplete="off"
                            :rules="numberstockRules"
                            :disabled="(isUser? true : false)"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>

                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                              v-model="equip_group_id"
                              :items="equipmentgroupdata"
                              item-value="equip_group_id"
                              item-text="equip_group_name"
                              :label="'Equipment groups' | translate"
                              :rules="equipmentgroupRules"
                              outlined
                              chips
                              small-chips
                              required
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                              v-model="equip_templates"
                              :items="equipmenttemplatedata"
                              item-value="temp_id"
                              item-text="temp_name"
                              :label="'Equipment Template' | translate"
                              :rules="CalibrationtemplateRules"
                              outlined
                              chips
                              multiple
                              small-chips
                              required
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :label="'Serial number' | translate"
                            v-model="serial_number"
                            name="serial_number"
                            autocomplete="off"
                            :disabled="(isUser? true : false)"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                              v-model="operational_status"
                              :items="operationals"
                              item-value="value"
                              item-text="text"
                              :label="'Operational status' | translate"
                              :rules="operationalStatusRules"
                              outlined
                              chips
                              small-chips
                              required
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                              >
                              <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                              v-model="equip_labels"
                              item-value="equip_label_id"
                              item-text="equip_label"
                              :items="equipmentlabeldata"
                              :label="'Category' | translate"
                              :disabled="(isUser? true : false)"
                              outlined
                              autocomplete="off"
                              chips
                              multiple
                              small-chips
                            >
                            <template v-slot:append-outer>
                              <v-btn large class="mt-n3 pt-4 pb-4" @click="show=!show" color="primary">{{ 'Add category' | translate }}</v-btn>
                            </template>
                            </v-autocomplete>
                        </v-col>

                          <v-col cols="12" v-show="show">
                            <v-text-field
                              outlined
                              :label="'Add category' | translate"
                              :disabled="(isUser? true : false)"
                              name="category"
                              v-model="equip_label"
                              autocomplete="off"
                            >
                              <template v-slot:append-outer>
                                <v-btn large class="mt-n3 pt-4 pb-4" @click="addCategory" color="primary">{{ 'Add' | translate }}</v-btn>
                              </template>
                            </v-text-field>
                          </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            type="number"
                            :label="'Inventory number' | translate"
                            v-model="inventory_num"
                            name="inventory_num"
                            autocomplete="off"
                            :disabled="(isUser? true : false)"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>                        
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="procedure"
                            v-model="procedure"
                            :disabled="(isUser? true : false)"
                            autocomplete="off"
                            :label="'Procedure' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="description"
                            v-model="description"
                            :disabled="(isUser? true : false)"
                            autocomplete="off"
                            :label="'Description' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row v-if="equipment_id !== null ">
                        <v-col cols="12" sm="12">
                          <div class="pb-4 title">{{ 'Equipment templates' | translate}}</div>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>

                      <v-row v-if="equipment_id !== null ">
                        <v-col cols="12">
                        <v-data-table
                          :headers="Calibrationtemplateheaders"
                          :items="userCalibrationTemplates"
                          :single-expand="singleExpand"
                          :expanded.sync="expanded"
                          item-key="temp_id"
                          show-expand
                          class="elevation-1"
                          :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                        >
                          <template slot="no-data">
                              {{ 'No data available' | translate }}
                          </template>
                            <template v-slot:footer.page-text="items">
                              {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }}
                            </template>
                          <template v-slot:item.template ="{ item }" >
                              <v-btn small color="primary" v-on:click="downloadCalibrationTemplate(item.temp_files[0])">{{ 'View'| translate }}</v-btn>
                          </template>
                          <template v-slot:item.update ="{ item }" >
                              <v-btn small color="primary" v-on:click="openDialog(item.temp_files[0].temp_id, item.temp_validity, item.temp_type)" >{{ 'Update document'| translate }}</v-btn>
                          </template>
                            <template v-slot:item.data-table-expand="{ item ,expand, isExpanded }">
                              <v-icon v-if="!isExpanded" @click="expand(!isExpanded); showUserDocuments(item.temp_files[0].temp_id)">mdi-chevron-down</v-icon>
                              <v-icon v-if="isExpanded" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
                            </template>
                          <template v-slot:expanded-item="{ headers }">
                            <td :colspan="headers.length" style='padding: 0px !important;'>
                            <v-data-table
                              :headers="subdocumentheaders"
                              :items="userdocuments"
                              item-key="created_at"
                              class="elevation-1"
                              hide-default-footer
                            >
                            <template slot="no-data">
                                {{ 'No data available' | translate }}
                            </template>
                            <template v-slot:footer.page-text="items">
                              {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }}
                            </template>
                            <template v-slot:item.view ="{ item }">
                                <v-btn small color="primary" v-on:click="downloadUser(item.ud_id, item.updated_at, item.extension)">{{ 'View'| translate }}</v-btn>
                            </template>
                            <template v-slot:item.edit ="{ item }">
                                <v-btn small color="primary" v-on:click="openeditDialog(item.ud_id,item.temp_id,item.due_date)">{{ 'Edit'| translate }}</v-btn>
                            </template>
                            </v-data-table>
                            </td>
                          </template>
                        </v-data-table>
                        </v-col>
                      </v-row>


                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-col v-if="url != null" cols="12" sm="12">
                          <v-img
                            :src="url"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            max-width="500"
                            max-height="300"
                          ></v-img>
                        </v-col>

                      <v-row>
                        <v-col cols="12" sm="12">
                            <v-file-input
                                id="equip_image"
                                name="file"
                                outlined
                                chips
                                required
                                :disabled="(isUser? true : false)"
                                :label="'Equipment image' | translate"
                                @change="onFileSelected"
                            >
                            <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-file-input>
                        </v-col>
                      </v-row>

                      <v-row>
                          <v-col cols="12" sm="12">
                            <v-checkbox :disabled="(isUser? true : false)" v-model="checkbox">
                              <template v-slot:label>
                                <div>
                                  {{ 'Remove out from Inbox' | translate}}
                                </div>
                              </template>
                            </v-checkbox>

                          </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="equipment_id != '' && !isUser"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="equipment_id && !isUser"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
                <v-dialog v-model="dialog" persistent max-width="500">
                  <v-card>
                    <v-card-title class="headline" v-if='editDocument'>{{ 'Edit Calibration document' | translate }}</v-card-title>
                    <v-card-title class="headline" v-else>{{ 'Update Calibration document' | translate }}</v-card-title>
                    <v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-form id="modelform" ref="modelform">
                              <v-row>

                                <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                                  <v-alert
                                    dense
                                    v-for="(v, k) in documenterrors"
                                    :key="k"
                                    outlined
                                    type="error"
                                  >{{ k }} {{ v }}</v-alert>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if='editDocument ==false'>
                                    <v-file-input
                                        id="document_file"
                                        name="file"
                                        outlined
                                        chips
                                        required
                                        :label="'Select file' | translate"
                                        @change="onFileSelectedTemplate"
                                    ></v-file-input>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-autocomplete
                                      v-model="status"
                                      :items="statusvalues"
                                      item-value="value"
                                      item-text="text"
                                      :label="'Status' | translate"
                                      :rules="statusRules"
                                      outlined
                                      chips
                                      small-chips
                                      required
                                      :no-data-text="$t('No data available')"
                                    >
                                    <template #message="{ message }">
                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="true"

                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        outlined
                                        :label="'Due date' | translate"
                                        v-model="due_date"
                                        name="due_date"
                                        :rules="dateRules"
                                        autocomplete="off"
                                        required
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"

                                      >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>
                                      </v-text-field>


                                    </template>
                                    <v-date-picker
                                      v-model="due_date"
                                      no-title
                                      scrollable
                                      :locale="curLanguage.lang_code"
                                      @input="menu=false"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-textarea
                                    outlined
                                    name="comment"
                                    v-model="comment"
                                    autocomplete="off"
                                    :label="'Comment (optional)' | translate"
                                  >
                                  <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>
                                  </v-textarea>
                                </v-col>

                              </v-row>

                            </v-form>
                          </v-container>
                        </v-card-text>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>



      <v-overlay :value="showLoader">
          <v-layout row justify-center v-if="showLoader">
            <v-dialog v-model="showLoader" persistent fullscreen content-class="loading-dialog">
              <v-container fill-height>
                <v-layout row justify-center align-center>
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-layout>
              </v-container>
            </v-dialog>
          </v-layout>
        </v-overlay>

    </v-container>
  </v-content>
</template>

<script>
import {
  ADD_EQUIPMENT,
  RESET_STATE,
  FETCH_INDIVIDUAL_EQUIPMENT,
  FETCH_EQUIPMENT_LABEL,
  FETCH_EQUIPMENT_GROUP_DATA,
  FETCH_EQUIPMENT_TEMPLATE_DATA,
  FETCH_USER_DOCUMENTS,
  UPDATE_USER_DOCUMENT,
  ADD_EQUIPMENT_LABEL_DATA,
  DOWNLOAD_USER_DOCUMENT,
  DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT,
  UPDATE_EQUIPMENT
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addeditEquipment",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_EQUIPMENT_LABEL, "")
    await store.dispatch(FETCH_EQUIPMENT_GROUP_DATA, "")
    await store.dispatch(FETCH_EQUIPMENT_TEMPLATE_DATA, "")
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_EQUIPMENT, to.params.id).then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualequipment",'userdocuments', 'equipmentlabeldata','currentUser','curLanguage', "equipmenttemplatedata","equipmentgroupdata"]),
    ...mapState({
      errors: state => state.equipment.equipmenterrors,
      curLanguage: state => state.translations.curLanguage,
      documenterrors: state => state.documents.documenterrors
    }),
    userCalibrationTemplates(){
      return this.equipmenttemplatedata.filter(o=> this.individualequipment.equip_templates.includes(o.temp_id))
    },
    subdocumentheaders(){
      return [
            { text: this.$t("Status"), value: "status" },
            { text: this.$t("Due date"), value: "due_date" },
            { text: this.$t("Uploaded by"), value: "uploaded_user" },
            { text: this.$t("Uploaded on"), value: "created_at" },
            { text: this.$t('Edit'), value: 'edit' },
            { text: this.$t('View'), value: 'view' },
          ]
    },
    Calibrationtemplateheaders(){
      return  [
        { text: this.$t('Equipment template name'), value: "temp_name" },
        {text: this.$t('Days until'), value: "temp_validity"},
        {text: this.$t('Template'), value:'template'},
        {text: this.$t('Update'), value:'update'},
        { text: '', value: 'data-table-expand' },
      ]
    },
    footertext(){
      return this.$t('Rows per page')
    },
    statusvalues(){
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    },

    locationRules(){ return [v => !!v || "Location is required"]},
    numberstockRules(){ return [v => !!v || "Number in stock is required"]},
    inventoryNumberRules(){ return [v => !!v || "Inventory number is required"]},
    equipmentgroupRules(){ return [v => !!v || "Equipment group is required"]},
    CalibrationtemplateRules(){ return [v => !!v || "Equipment template is required"]},
    equipmentnameRules(){return [v => !!v || "Equipment name is required"]},
    statusRules(){
      return [v => !!v || "Status is required"]
    },
    dateRules(){
      return [v => !!v || "Date is required"]
    },
    thumbnailRules(){ return [
      v => !!v || 'Thumbnail is required',
      v => (v && v.size > 0) || 'Thumbnail is required',
    ]},
    operationalStatusRules(){ return [v => !!(v && v.length) || "Operational status is required"]},
    operationals(){
      return [
          {value: 'not-operational', text:this.$t('Not operational')},
          {value: 'operational', text:this.$t('Operational')}
      ]
    },
    isUser(){
      return this.currentUser.roles.includes(4) 
    } 
  },
  created(){
    if(JSON.parse(this.currentUser.company.company_meta).has_equip_db == "false"){
      this.$router.push('/dashboard');
    }
  },
  mounted () {
    if(Object.keys(this.individualequipment).length > 0){
      this.equipment_id = this.individualequipment.equipment_id
      this.location = this.individualequipment.location
      this.equipmentclass = this.individualequipment.class
      this.serial_number  = this.individualequipment.serial_number
      this.maker  = this.individualequipment.maker
      this.operational_status  = this.individualequipment.operational_status
      this.num_in_stock = this.individualequipment.num_in_stock
      this.procedure  = this.individualequipment.procedure
      this.description  = this.individualequipment.description
      this.equip_group_id = this.individualequipment.equip_group_id
      this.equip_templates = this.individualequipment.equip_templates
      this.equip_name = this.individualequipment.equip_name
      this.equip_labels = this.individualequipment.equip_labels
      this.inventory_num = this.individualequipment.inventory_num
      this.checkbox = this.individualequipment.status == 'inactive' ? true : false
      this.url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL + this.individualequipment.equip_image
    }
  },
  data: function() {
    return {
      equip_name:null,
      file_template: null,
      equipment_id: null,
      equip_group_id:null,
      equip_templates:[],
      expanded: [],
      singleExpand: true,
      location: null,
      equipmentclass: null,
      menu: false,
      maker: null,
      num_in_stock: null,
      serial_number: null,
      inventory_num: null,
      procedure: null,
      description: null,
      equip_labels:[],
      equip_label:null,
      show: false,
      showLoader: false,
      doc_id: null,
      due_date: null,
      status: null,
      comment: null,
      personaldocumentid: null,
      file: null,
      temp_type: null,
      dialog: false,
      editDocument: false,
      operational_status:null,
      checkbox: false,
      url: null,
      
    }
  },
  methods : {
    async downloadCalibrationTemplate(documentdata){
      await this.$store
        .dispatch(DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT, 'view-file/'+documentdata.temp_file_id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', documentdata.updated_at+'.'+documentdata.extension);
          document.body.appendChild(fileLink);
          fileLink.click();
          store.commit(SET_LOADING, false);

        });
    },
    async downloadUser(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click();
          store.commit(SET_LOADING, false);

        });
    },
    openDialog(id, days, type){
      var currentDate = new Date()
      var validdate = new Date()
      validdate.setDate(currentDate.getDate()+days)
      this.dialog= true
      this.doc_id = id
      this.file=  null
      this.comment  = null
      this.due_date = validdate.toISOString().slice(0,10)
      this.status = null
      this.temp_type = type
      document.getElementById('document_file').value=''
    },
    openeditDialog(udid, idpersonaldocument,  duedate){
      this.dialog= true
      this.doc_id = udid
      this.file=  null
      this.personaldocumentid = idpersonaldocument
      this.comment  = null
      this.due_date = duedate
      this.status = null
      this.editDocument = true
    },
    closeBox(){
      document.getElementById("modelform").reset();
      this.dialog = false
      this.editDocument = false
    },
    async showUserDocuments(tempid){
      await this.$store.dispatch(FETCH_USER_DOCUMENTS,'?item_id='+this.individualequipment.equipment_id+'&temp_id='+tempid+'&inbox_filter=false').then(resp=>{
        if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
          this.$store.commit(SET_LOADING, false)
        }
        else{
          this.$store.commit(SET_LOADING, false)
        }
      })
    },
    onFileSelectedTemplate() {
      this.filetemplate = document.getElementById("document_file").files[0];
    },
    onFileSelected() {
      this.file = document.getElementById("equip_image").files[0];
      this.url = URL.createObjectURL(this.file ); 
    },
    async editPersonalDocument(){
      if (this.$refs.modelform.validate()) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("item_id", this.individualequipment.equipment_id)
          formData.set("temp_id", this.personaldocumentid)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          formData.set('ud_id', this.doc_id)
          formData.set('_method', 'put')
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.personaldocumentid)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Calibration document updated successfully'})
                  this.dialog =false
                  this.doc_id = null
                  this.filetemplate=  ''
                  this.comment  = ''
                  this.due_date = ''
                  this.status = ''
                  this.editDocument = false
                  this.personaldocumentid = null
                  this.$refs.modelform.reset()
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });


      }
    },
    async uploadDocument(){
      if (this.$refs.modelform.validate()) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("file", this.filetemplate)
          formData.set("item_id", this.individualequipment.equipment_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.doc_id)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Calibration document updated successfully'})
                  this.$refs.modelform.reset()
                  this.dialog =false
                  this.doc_id = null
                  this.filetemplate=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.personaldocumentid = null
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    addCategory(){
      this.showLoader = true
      this.$store.dispatch(ADD_EQUIPMENT_LABEL_DATA,{equip_label:this.equip_label }).then(response =>{
        if(response.hasOwnProperty('success') && response.success){
          store.dispatch(FETCH_EQUIPMENT_LABEL,'').then(()=>{
            this.equip_labels.push(response.data.equip_label_id);
            this.equip_label=null
            this.show = false
            this.showLoader = false
            store.commit(SET_LOADING, false)
          })
        }
        else{
          store.commit(SET_LOADING, false)
        }
      })
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
            if (this.file != null) {
                formData.set("equip_image", this.file);
            }
            formData.set('equip_name',this.equip_name)
            formData.set('location',this.location)
            formData.set('class',this.equipmentclass)
            formData.set('inventory_num',this.inventory_num)
            formData.set('maker', this.maker)
            formData.set('operational_status', this.operational_status)
            formData.set('serial_number', this.serial_number)
            formData.set('num_in_stock', this.num_in_stock)
            formData.set('procedure', this.procedure)
            formData.set('equip_group_id', this.equip_group_id)
            formData.set('status', (this.checkbox? 'inactive': 'active'))
            this.equip_templates.forEach(function(item) {
                formData.append("equip_templates[]", item)
            });
            this.equip_labels.forEach(function(item) {
                formData.append("equip_labels[]", item)
            });
        this.$store
          .dispatch(ADD_EQUIPMENT, formData )
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Equipment created successfully'})
              this.$router.push({ name: "equipment" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
            if (this.file != null) {
                formData.set("equip_image", this.file);
            }
            formData.set('equipment_id',this.equipment_id)
            formData.set('equip_name',this.equip_name)
            formData.set('location',this.location)
            formData.set('class',this.equipmentclass)
            formData.set('inventory_num',this.inventory_num)
            formData.set('maker', this.maker)
            formData.set('operational_status', this.operational_status)
            formData.set('serial_number', this.serial_number)
            formData.set('num_in_stock', this.num_in_stock)
            formData.set('procedure', this.procedure)
            formData.set('equip_group_id', this.equip_group_id)
            formData.set('status', (this.checkbox? 'inactive': 'active'))
            this.equip_templates.forEach(function(item) {
                formData.append("equip_templates[]", item)
            });
            this.equip_labels.forEach(function(item) {
                formData.append("equip_labels[]", item)
            });
            formData.set('_method','put')


        this.$store
          .dispatch(UPDATE_EQUIPMENT, formData)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Equipment updated successfully'})
              this.$router.push({ name: "equipment" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>
